import { render, staticRenderFns } from "./dataDialog.vue?vue&type=template&id=470028d8&scoped=true&"
import script from "./dataDialog.vue?vue&type=script&lang=js&"
export * from "./dataDialog.vue?vue&type=script&lang=js&"
import style0 from "./dataDialog.vue?vue&type=style&index=0&id=470028d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470028d8",
  null
  
)

export default component.exports